
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../services/timesheetreportsService';
import {timesheetService} from '../services/timesheetService';
import {timesheetuserService} from '../services/timesheetUserservice';
import {formatterhelper} from '../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch, FaTrash } from "react-icons/fa";
import Smallloader from '../compnents/loader';
import {adminService} from '../services/adminService';
import { Toast } from 'primereact/toast';

const Holidays = ({tabname}) => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        holidaydate: '',
        holidaycountry: 'in',
        holidaytext: '',
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const rolesdata = localStorage.getItem('role') != '' ? JSON.parse(localStorage.getItem('role')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState(null);
    const [errors, setErrors] = useState({});
     
    const [formData2, setForm2Data] = useState({
        selectedclient: '',
        selectedsubclient: '',
        task:'',
        minutes:'',
        billedminutes:'',
        budgethours:'',
        remainingbudgethours:'',
        count:'',
        fillingfor:'',
        remarks:''
      });
     
    useEffect(()=>{
        // _getproject();
        getholiday();
    },[]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
     };

    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log('form daat');
        let date = formatterhelper.dateformatter({date:formData.holidaydate})  
        // console.log(formData);
        let obj = {
            ...formData,
            holidaydate_temp:date
        }
        addholiday(obj);    
        // addproject({project:formData.projectname});
    };


    function addholiday(obj){
    //   console.log(obj);   
      let objstr = JSON.stringify(obj);
      timesheetService.addholiday(objstr).then((response)=>{ 
        // console.log("response");  
        // console.log(response);
        if(response.status == 200){
            toast.current.show({ severity: 'success', summary: 'Holiday', detail: 'Holiday Added successfully', life: 3000 });   
            setFormData({
                holidaydate: '',
                holidaycountry: 'in',
                holidaytext: '',
            });

            getholiday();
        }else{
            toast.current.show({ severity: 'error', summary: 'Holiday', detail: 'Holiday not Added', life: 3000 });    
    
        }
      }).catch((error)=>{
         console.log(error);
         toast.current.show({ severity: 'error', summary: 'Holiday', detail: 'Error', life: 3000 });
         setFormData({
            holidaydate: '',
            holidaycountry: 'in',
            holidaytext: '',
        });   
      });
    }

    function getholiday(){
        let emparr = [];
        setloading(false);
        timesheetService.getholiday().then((response)=>{
             if(response.status == 200){
                  console.log(response.data,'get holiday');
                   setDatacomp(response.data.data);
                   setloading(true);
                   setDatastate(true);
             }else{
                setDatacomp([]);
                setloading(true);
                setDatastate(true);
             }
        }).catch((error)=>{
            setDatacomp([]);
            setloading(true);
            setDatastate(true);
        }); 
    }

    function displayholiday(){
        let emparr = [];
        datacomp.forEach((value,index)=>{
            emparr.push(<tr>
                <td>{index + 1}</td>
                <td><h5>{value.formatted_date}</h5></td>
                <td><h5>{value.country}</h5></td>
                <td>{value.value}</td>
               
                
             </tr>);
        }); 
        return emparr;
    }

    const validateForm = () => {
        let valid = true;
        const newErrors = {};
       if (formData.projectname == '') {
          newErrors.projectname = 'Project name is required';
          valid = false;
        }

        setErrors(newErrors);

       return valid; 
    }

    function deleteholiday(id){
        console.log(id);
        timesheetService.deleteholiday(id).then((response)=>{
            if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Holiday', detail: 'Holiday deleted successfully', life: 3000 });     
                getholiday();
            }else{
              toast.current.show({ severity: 'error', summary: 'Holiday', detail: 'Not deleted', life: 3000 });      

            } 
        }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: 'Holiday', detail: 'Error', life: 3000 });       
        });
    }

    function yearlists(){
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let year = currentYear; year >= currentYear - 3; year--) {
            let data = <option value={year}>{year}</option>
            years.push(data);
        }
       return years;
    }

    function particularholidays(e){
        console.log("particular holiday");
        console.log(e.target.value);
        setloading(false);
        setDatastate(false); 
        let year = e.target.value;
        timesheetService.getparticularholiday(year).then((response)=>{
           if(response.status == 200){
                  console.log(response);
                  console.log("response"); 
                  setDatacomp(response.data.data);
                  setloading(true);
                  setDatastate(true);
           }else{
                console.log("201");
                setDatacomp([]);
                setloading(true);
                setDatastate(false);
           }
        }).catch((error)=>{
            setDatacomp([]);   
            setloading(true);
            setDatastate(false);
        });

    }

    return (
        <>
             <Toast ref={toast} />
            <div className="invisible-divider-sm"></div>
            <h6 className='card-style-padding-two'>{tabname}</h6>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-9'></div>
                    <div className='pagination col-md-3'>
                        {rolesdata != null &&  rolesdata != undefined && (rolesdata.rolename == 'superadmin' || rolesdata.rolename == 'admin') ? (<select className='form-control' onChange={(e) => particularholidays(e)}>
                            {yearlists()}
                        </select>) :(<></>)}
                        {/* <select className='form-control' onChange={(e) => particularholidays(e)}>
                            {yearlists()}
                        </select> */}
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                    </div>
                </div>
               
               
                <div className='row'>
                    <div className='col-md-12'>
                     <br/>  
                     <a
                    href={`https://corientbs.hrstop.com/Home/Holidays?yr=${new Date().getFullYear()}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    Please follow this link
                    </a>

                    {/* {!isloaded ? loader.Loadermd() : dataavail ? */}
                    {/* // (<table class="table table-bordered">
                    //     <thead>
                    //         <tr>
                    //             <th scope="col">SR No</th>
                    //             <th scope="col">Date</th>
                    //             <th scope="col">country</th>
                    //             <th scope="col">holiday</th>
                           
                    //         </tr>
                    //     </thead>
                    //     <tbody>
                    //         {displayholiday()}
                    //     </tbody>
                    // </table>) :  */}
                    {/* (<p>No data Found</p>)}  */}
                    </div>
                   
                </div>
                <br/> 
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Holidays;
